module.exports = "<div class=\"Conversation-trip-container\" ng-style=\"{'width': $ctrl.avatarWidth }\">\n  <div ng-repeat=\"avatar in $ctrl.avatars\">\n    <div class=\"ConversationTrip-avatar\"\n      ng-style=\"{'left': avatar.shift, 'z-index': avatar.z_index, 'background': avatar.path, 'background-size': 'contain'}\"\n      ng-if=\"$index < 5\">\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/components/conversations_trips/conversation_trip_avatar/conversation_trip_avatar.html
// module id = 400
// module chunks = 24